// styles/Footer.styles.js
const FooterStyles = {
  footerContainer: {
    backgroundColor: '#000000', // Dark green background
    color: '#FFFFFF', // White text
    padding: '50px 20px',
    textAlign: 'center',
  },
  sectionTitle: {
    fontWeight: 'bold',
    fontSize: '1.3rem',
    marginBottom: '12px',
    color: '#81c241', // Lime green for titles
  },
  sectionText: {
    fontSize: '0.95rem',
    color: '#f9f9f9', // Lighter gray for contrast against dark green
    maxWidth: '300px',
    margin: '0 auto',
    lineHeight: '1.6',
  },
  linksContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'center',
  },
  link: {
    color: '#f9f9f9', // Lighter gray for links
    fontSize: '1rem',
    textDecoration: 'none',
    transition: 'color 0.3s ease, transform 0.2s ease',
    '&:hover': {
      color: '#81c241', // Lime green on hover
      textDecoration: 'underline',
      transform: 'translateX(5px)', // Slight shift for interactivity
    },
  },
  socialContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px', // Increased spacing for better layout
    marginTop: '15px',
    flexWrap: 'wrap', // Wraps icons on smaller screens
  },
  socialIcon: {
    fontSize: '2rem', // Larger icons
    color: '#f9f9f9', // Lighter gray for icons
    transition: 'color 0.3s ease, transform 0.3s ease',
    '&:hover': {
      color: '#81c241', // Lime green on hover
      transform: 'scale(1.2)', // Slight scale-up effect
    },
  },
  divider: {
    backgroundColor: '#81c241', // Lime green divider
    opacity: 0.5, // Slightly more visible
    margin: '30px auto',
    width: '70%', // Slightly wider
  },
  bottomContainer: {
    marginTop: '15px',
    fontSize: '0.85rem',
    color: '#f9f9f9', // Lighter gray for bottom text
  },
};

export default FooterStyles;